import { render, staticRenderFns } from "./admin_contacts.vue?vue&type=template&id=096e8640&scoped=true&"
import script from "./admin_contacts.vue?vue&type=script&lang=js&"
export * from "./admin_contacts.vue?vue&type=script&lang=js&"
import style0 from "./admin_contacts.vue?vue&type=style&index=0&id=096e8640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e8640",
  null
  
)

export default component.exports